"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERATE_API_KEY_SUCCESSFULLY = exports.OPEN_API_KEY_MODAL = exports.CLOSE_API_KEY_MODAL = exports.USER_HAS_NO_API_KEY = exports.USER_HAS_API_KEY = void 0;
exports.USER_HAS_API_KEY = 'USER_HAS_API_KEY';
exports.USER_HAS_NO_API_KEY = 'USER_HAS_NO_API_KEY';
exports.CLOSE_API_KEY_MODAL = 'CLOSE_API_KEY_MODAL';
exports.OPEN_API_KEY_MODAL = 'OPEN_API_KEY_MODAL';
exports.GENERATE_API_KEY_SUCCESSFULLY = 'GENERATE_API_KEY_SUCCESSFULLY';
